import { CarrierOrder } from "api/logistics/carrierOrders/models";
import { InfoLabel } from "components/common/infoLabel";
import { Avatar } from "components/miloDesignSystem/atoms/avatar";
import { Tag } from "components/miloDesignSystem/atoms/tag";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { RightPanelSection } from "components/utils/drawer";
import { dateFns } from "utilities";
import { paymentMethodDict } from "../../hooks/useCarrierOrdersListColumns";

interface Props {
  carrierOrder: CarrierOrder;
}

export const GeneralInfoSection = ({ carrierOrder }: Props) => {
  return (
    <RightPanelSection>
      <div className="d-flex align-items-center mb-2">
        <Typography fontSize="26" fontWeight="700">
          {carrierOrder.route.signature}
        </Typography>
      </div>
      <InfoLabel title="przewoźnik">
        <div>
          <Typography fontSize="14" fontWeight="700">
            {carrierOrder.carrier.companyName}
          </Typography>
          <div className="d-flex align-items-center gap-1">
            <Typography fontSize="14" fontWeight="600">
              {carrierOrder.carrier.street},
            </Typography>
            <Typography fontSize="14" fontWeight="600">
              {carrierOrder.carrier.postCode}
            </Typography>
            <Typography fontSize="14" fontWeight="600">
              {carrierOrder.carrier.city}
            </Typography>
          </div>
        </div>
      </InfoLabel>
      <InfoLabel title="data zlecenia">
        <Typography fontSize="14" fontWeight="400">
          {dateFns.format(new Date(carrierOrder.createdAt), "dd.MM.yyyy, H:mm")}
        </Typography>
      </InfoLabel>
      <InfoLabel title="zlecono przez">
        <>
          <Avatar size="sm" user={carrierOrder.createdBy} theme="light" />
          <div className="overflow fw-700 fs-12">
            {carrierOrder.createdBy.firstName} {carrierOrder.createdBy.lastName}
          </div>
        </>
      </InfoLabel>
      <InfoLabel title="nr rejestracyjny">
        <Typography fontSize="14" fontWeight="700">
          {carrierOrder.car.registrationNumber}
        </Typography>
      </InfoLabel>
      <InfoLabel title="kierowcy">
        {carrierOrder.drivers.length > 0 ? (
          carrierOrder.drivers.map(driver => (
            <Typography fontSize="14" fontWeight="600" key={driver.id}>
              {driver.firstName} {driver.lastName}
            </Typography>
          ))
        ) : (
          <Typography fontSize="14" fontWeight="700">
            ---
          </Typography>
        )}
      </InfoLabel>
      <InfoLabel title="data załadunku">
        <Typography fontSize="14" fontWeight="700">
          ---
        </Typography>
      </InfoLabel>
      <InfoLabel title="data wyjazdu">
        <Typography fontSize="14" fontWeight="700">
          ---
        </Typography>
      </InfoLabel>
      <InfoLabel title="sposób zapłaty">
        {Boolean(carrierOrder.paymentMethod) ? (
          <Tag
            label={paymentMethodDict[carrierOrder.paymentMethod].label}
            variant={paymentMethodDict[carrierOrder.paymentMethod].variant}
          />
        ) : (
          <Typography fontSize="14" fontWeight="700">
            ---
          </Typography>
        )}
      </InfoLabel>
    </RightPanelSection>
  );
};
